/* eslint-disable react/no-danger */
// In our particular case, it's save to insert html for the server, as we control
// everything what is displayed on the page.

import React from 'react';

import createStyles from "./styles";

var TextEntity = function TextEntity(props) {
  var label = props.label,prefix = props.prefix;
  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("p", { className: classes.wrapper },
    prefix && /*#__PURE__*/React.createElement("span", { className: classes.prefix }, prefix), /*#__PURE__*/
    React.createElement("span", { className: classes.text, dangerouslySetInnerHTML: { __html: label } })));


};

export default TextEntity;
//# sourceMappingURL=index.js.map